module.exports = __webpack_public_path__ + "static/pedagogy@large-137c29d8fd2a93dc18434ca817c9b867.jpg";